'use client';

import { useEffect, useState } from 'react';
import { useBrowserState } from '@/src/lib/use-browser-state';
import {
  endImpersonation,
  formatImpersonationDuration,
  getActiveImpersonation,
  isImpersonationExpired,
  type ImpersonationSession,
} from '@/src/lib/impersonation';

export function ImpersonationBanner() {
  const [session, setSession, , refresh] = useBrowserState(getActiveImpersonation, null);

  useEffect(() => {
    const interval = setInterval(() => {
      refresh();
    }, 5000);
    return () => clearInterval(interval);
  }, [refresh]);

  if (!session) return null;

  const expired = isImpersonationExpired(session) || session.endedAt != null;

  function handleEnd() {
    endImpersonation(session!.id);
    setSession(null);
    window.location.href = '/admin/impersonation-log';
  }

  return (
    <div
      role="alert"
      data-tour="impersonation-banner"
      className="fixed bottom-0 left-0 right-0 z-[90] flex items-center justify-between gap-3 border-t-2 border-[var(--k-color-warning)] bg-[var(--k-color-warning-soft)] px-4 py-2 shadow-[var(--k-shadow-md)]"
    >
      <div className="flex items-center gap-3 text-sm">
        <span aria-hidden="true" className="text-xl">⚠</span>
        <div>
          <p className="font-semibold text-[var(--k-color-warning-strong)]">
            Impersonation-Modus aktiv
          </p>
          <p className="text-xs text-[var(--k-color-text-secondary)]">
            {session.adminEmail} → <strong>{session.targetEmail}</strong> · {formatImpersonationDuration(session)} · Grund: {session.reason}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={handleEnd}
        data-tour="impersonation-end"
        className="rounded-md bg-[var(--k-color-warning-strong)] px-4 py-2 text-sm font-bold text-[var(--k-color-text-primary)]"
      >
        Impersonation beenden
      </button>
    </div>
  );
}
